import React from "react";
import { Container } from "react-bootstrap";
import Slider from "react-slick";

const Partners = () => {
  const logos1 = [
    {
      image:
        "./img/plus-distribution-client-sanofi.webp",
    },
    {
      image:
        "./img/plus-distribution-client-aristo.webp",
    },
    {
      image:
        "./img/plus-distribution-client-mankind.webp",
    },
    {
      image:
        "./img/plus-distribution-client-lupin.webp",
    },
    {
      image:
        "./img/plus-distribution-client-GSK.webp",
    },
    {
      image:
        "./img/plus-distribution-client-macleods.webp",
    },
    {
      image:
        "./img/plus-distribution-client-johnson.webp",
    },
    {
      image:
        "./img/plus-distribution-client-turant.webp",
    },
    {
      image:
        "./img/plus-distribution-client-natco.webp",
    },
    {
      image:
        "./img/plus-distribution-client-nipro.webp",
    },
    {
      image:
        "./img/plus-in-distribution-canam.webp",
    },
    {
      image:
        "./img/plus-in-distribution-polymed.webp",
    },
    {
      image:
        "./img/plus-in-distribution-alkem.webp",
    },
    {
      image:
        "./img/plus-distribution-client-aishwarya.webp",
    },
    {
      image:
        "./img/plus-distribution-client-3M.webp",
    },
    {
      image:
        "./img/plus-distribution-client-THEMIS.webp",
    },
  ];
  const logos2 = [
    {
      image:
        "./img/plus-distribution-client-cipla.webp",
    },
    {
      image:
        "./img/plus-distribution-client-RUSCH.webp",
    },
    {
      image:
        "./img/plus-distribution-client-tynor.webp",
    },
    {
      image:
        "./img/plus-distribution-client-MGRM.webp",
    },
    {
      image:
        "./img/plus-distribution-client-hollister.webp",
    },
    {
      image:
        "./img/plus-distribution-client-TROIKA.webp",
    },
    {
      image:
        "./img/plus-distribution-client-PFIZER.webp",
    },
    {
      image:
        "./img/plus-distribution-client-DR-REDDY.webp",
    },
    {
      image:
        "./img/plus-distribution-client-surziwear.webp",
    },
    {
      image:
        "./img/plus-distribution-client-MYLAN.webp",
    },
    {
      image:
        "./img/plus-distribution-client-Glenmark.webp",
    },
    {
      image:
        "./img/plus-distribution-client-BD.webp",
    },
    {
      image:
        "./img/plus-distribution-client-BDB.webp",
    },
    {
      image:
        "./img/plus-distribution-client-USV.webp",
    },
    {
      image:
        "./img/plus-distribution-client-SUN.webp",
    },
  ];
  const settings1 = {
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    cssEase: "linear",
    pauseOnHover: false,
    autoplaySpeed: 1,
    speed: 6000,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3.01,
        },
      },
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 426,
        settings: {
          slidesToShow: 2.2,
        },
      },
    ],
  };
  const settings2 = {
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    autoplaySpeed: 1,
    speed: 6000,
    rtl: true,
    cssEase: "linear",
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 426,
        settings: {
          slidesToShow: 2.2,
        },
      },
    ],
  };
  return (
    <>
      <Container
        fluid
        className="overflow-hidden d-flex flex-column py-5 max-w-1920 mx-auto"
      >
        <h2
          className="fw-bold fs_8xl mb-2 text-center mb-5 text-black"
          data-aos="fade-down"
        >
          Our Associations
        </h2>
        <div data-aos="zoom-in">
          <Slider {...settings1}>
            {logos1.map((a, index) => (
              <div key={index} className="logo_bg">
                <div>
                  <img loading="lazy" 
                    src={a.image}
                    alt="Partners Of PDPL"
                    width={146}
                    height={168}
                    className="object-fit-contain px-2 mx-auto"
                  />
                </div>
              </div>
            ))}
          </Slider>
        </div>
        <div data-aos="zoom-in">
          <Slider {...settings2}>
            {logos2.map((a, index) => (
              <div key={index} className="logo_bg">
                <img loading="lazy" 
                  src={a.image}
                  alt="Partners Of PDPL"
                  width={146}
                  height={168}
                  className="object-fit-contain px-2 mx-auto"
                />
              </div>
            ))}
          </Slider>
        </div>
      </Container>
    </>
  );
};

export default Partners;
